// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__tMpT9","wrapper":"Header_wrapper__b6qoA","logo":"Header_logo__uwk2r"};